import React from "react";
import { useTranslation } from "react-i18next";
import U2000BasicDialog from "../../../u2000Core/components/dialog/U2000BasicDialog";
import type { U3134GenerateWipProgressData } from "../../U3134Service";
import { NS } from "../../U3134";

interface U3134GenerateWipRecapDialogProps {
  isOpen: boolean;
  recap: { title: string; message: string; importance: "success" | "warning" | "error" } | null;
  progressData: U3134GenerateWipProgressData | null;
  onClose: () => void;
}

const U3134GenerateWipRecapDialog: React.FC<U3134GenerateWipRecapDialogProps> = ({ isOpen, recap, progressData, onClose }) => {
  const { t } = useTranslation();
  const counters = progressData?.counters;

  return (
    <U2000BasicDialog isOpen={isOpen} onClose={onClose} title={recap?.title ?? t("lblGenerateWipRecapTitle", { ns: NS })} width="small">
      <div className="space-y-4 px-6 py-4">
        <p
          className={`text-sm ${
            recap?.importance === "error" ? "text-red-700" : recap?.importance === "warning" ? "text-amber-700" : "text-green-700"
          }`}
        >
          {recap?.message}
        </p>
        <div className="grid grid-cols-2 gap-2 text-sm text-gray-700">
          <div>{t("lblGenerateWipCounterPromoted", { ns: NS })}</div>
          <div className="text-right font-semibold">{counters?.promoted ?? 0}</div>
          <div>{t("lblGenerateWipCounterProcessed", { ns: NS })}</div>
          <div className="text-right font-semibold">{counters?.processed ?? 0}</div>
          <div>{t("lblGenerateWipCounterSucceeded", { ns: NS })}</div>
          <div className="text-right font-semibold">{counters?.succeeded ?? 0}</div>
          <div>{t("lblGenerateWipCounterFailed", { ns: NS })}</div>
          <div className="text-right font-semibold">{counters?.failed ?? 0}</div>
        </div>
        <div className="text-sm text-gray-700">
          {t("lblGenerateWipLastEmployee", { ns: NS, employeeName: progressData?.lastResult?.employeeName ?? t("lblUnknownEmployee", { ns: NS }) })}
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-700"
          >
            {t("btnClose", { ns: NS, defaultValue: "Fermer" })}
          </button>
        </div>
      </div>
    </U2000BasicDialog>
  );
};

export default U3134GenerateWipRecapDialog;
